import { axiosObject } from "../config";

function getTeams() {
    return new Promise((resolve, reject) => {
        let uri = "access/teams";

        axiosObject
            .get(uri)
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

export { getTeams }